import { useTranslation } from 'react-i18next'
import { FieldDropdown } from '@/components/form'

const LeaseEndActionField = ({ isAlberta }) => {
  const { t } = useTranslation()

  return (
    <FieldDropdown
      name="lease_end_action"
      placeholder={t('l.contract.edit.lease_end_action.label', 'When lease expires')}
      required
      options={[
        ...(!isAlberta
          ? [
              {
                value: 'continue_month_to_month',
                label: t('l.contract.edit.continue_monthly.label', 'Continue month to month')
              }
            ]
          : []),
        {
          value: 'tenant_must_vacate',
          label: t('l.contract.edit.must_move_out.label', 'Tenant must move out')
        }
      ]}
    />
  )
}

export default LeaseEndActionField
